/* eslint-disable @typescript-eslint/no-explicit-any */

// Import English translations statically
import missionsEn from "../../locales/en/missions.json";
import changelogEn from "../../locales/en/changelog.json";
import leaderboardEn from "../../locales/en/leaderboard.json";
import basecampEn from "../../locales/en/basecamp.json";
import preferencesEn from "../../locales/en/preferences.json";
import replayTutorialEn from "../../locales/en/replayTutorial.json";
import squadListEn from "../../locales/en/squadList.json";
import squadPerformanceSheetEn from "../../locales/en/squadPerformanceSheet.json";
import createSquadSheetEn from "../../locales/en/createSquadSheet.json";
import tokenSelectionSheetContentEn from "../../locales/en/tokenSelectionSheetContent.json";
import deleteSquadSheetEn from "../../locales/en/deleteSquadSheet.json";
import referralsEn from "../../locales/en/referrals.json";
import referrerPageEn from "../../locales/en/referrerPage.json";
import practiceEn from "../../locales/en/practice.json";
import navigationPracticeEn from "../../locales/en/navigationPractice.json";
import directionToggleEn from "../../locales/en/directionToggle.json";
import squadListSheetContentEn from "../../locales/en/squadListSheetContent.json";
import navigationPracticeLiveEn from "../../locales/en/navigationPracticeLive.json";
import userRankCardEn from "../../locales/en/userRankCard.json";
import navigationPracticeEndedEn from "../../locales/en/navigationPracticeEnded.json";
import practiceLiveEn from "../../locales/en/practiceLive.json";
import practiceEndedEn from "../../locales/en/practiceEnded.json";
import itemRouletteDialogEn from "../../locales/en/itemRouletteDialog.json";
import itemDoubleTrophyDialogEn from "../../locales/en/itemDoubleTrophyDialog.json";
import itemFreePassExpiredInfoDialogEn from "../../locales/en/itemFreePassExpiredInfoDialog.json";
import itemWinterCupDialogEn from "../../locales/en/itemWinterCupDialog.json";
import inventoryEn from "../../locales/en/inventory.json";
import rouletteEn from "../../locales/en/roulette.json";
import gachaTaskEn from "../../locales/en/gachaTask.json";
import homeCanvasEn from "../../locales/en/homeCanvas.json";
import landingPageEn from "../../locales/en/landingPage.json";
import arenaEn from "../../locales/en/arena.json";
import kothEn from "../../locales/en/koth.json";
import kothSquadSelectionViewEn from "../../locales/en/kothSquadSelectionView.json";
import kothNavigationDetailsEn from "../../locales/en/kothNavigationDetails.json";
import kothNavigationEndedEn from "../../locales/en/kothNavigationEnded.json";
import kothNavigationLiveEn from "../../locales/en/kothNavigationLive.json";
import kothNavigationViewsEn from "../../locales/en/kothNavigationViews.json";
import kothCardGlobalEn from "../../locales/en/kothCardGlobal.json";
import profileEn from "../../locales/en/profile.json";
import socialLinkDialogEn from "../../locales/en/socialLinkDialog.json";
import withdrawSheetEn from "../../locales/en/withdrawSheet.json";
import depositSheetEn from "../../locales/en/depositSheet.json";
import withdrawAlertEn from "../../locales/en/withdrawAlert.json";
import rushHistoryEn from "../../locales/en/rushHistory.json";
import tournamentCardEn from "../../locales/en/tournamentCard.json";
import matchCardEn from "../../locales/en/matchCard.json";
import kothCardEn from "../../locales/en/kothCard.json";
import kothHistoryEn from "../../locales/en/kothHistory.json";
import rushEn from "../../locales/en/rush.json";
import claimBorderDialogEn from "../../locales/en/claimBorderDialog.json";
import rushLeaderboardEn from "../../locales/en/rushLeaderboard.json";
import rollingListEn from "../../locales/en/rollingList.json";
import payoutDialogRushEn from "../../locales/en/payoutDialogRush.json";
import winnerTakesAllDetailsEn from "../../locales/en/winnerTakesAllDetails.json";
import winnerTakesAllHistoryEn from "../../locales/en/winnerTakesAllHistory.json";
import wtaRoomListEn from "../../locales/en/wtaRoomList.json";
import winnerTakesAllViewEn from "../../locales/en/winnerTakesAllView.json";
import hostedTournamentEn from "../../locales/en/hostedTournament.json";
import hostedTournamentCardEn from "../../locales/en/hostedTournamentCard.json";
import hostedTournamentDetailsEn from "../../locales/en/hostedTournamentDetails.json";
import hostedTournamentOpenEn from "../../locales/en/hostedTournamentOpen.json";
import hostedTournamentViewEn from "../../locales/en/hostedTournamentView.json";
import shareButtonDialogEn from "../../locales/en/shareButtonDialog.json";
import hostedTournamentHistoryEn from "../../locales/en/hostedTournamentHistory.json";
import matchHistoryEn from "../../locales/en/matchHistory.json";
import tournamentHistoryEn from "../../locales/en/tournamentHistory.json";
import wtaHistoryEn from "../../locales/en/wtaHistory.json";
import createTournamentEn from "../../locales/en/createTournament.json";
import tournamentSummaryDialogEn from "../../locales/en/tournamentSummaryDialog.json";
import squadMatchTypeSheetEn from "../../locales/en/squadMatchTypeSheet.json";
import playersJoinListEn from "../../locales/en/playersJoinList.json";
import tournamentDetailsEn from "../../locales/en/tournamentDetails.json";
import tournamentOpenEn from "../../locales/en/tournamentOpen.json";
import tournamentEndedEn from "../../locales/en/tournamentEnded.json";
import dayTournamentViewEn from "../../locales/en/dayTournamentView.json";
import payoutDialogEn from "../../locales/en/payoutDialog.json";
import chatWidgetEn from "../../locales/en/chatWidget.json";
import navigationMatchEn from "../../locales/en/navigationMatch.json";
import joinButtonEn from "../../locales/en/joinButton.json";
import entriesCounterEn from "../../locales/en/entriesCounter.json";
import navigationRushEn from "../../locales/en/navigationRush.json";
import autoJoinSheetEn from "../../locales/en/autoJoinSheet.json";
import roundsCounterEn from "../../locales/en/roundsCounter.json";
import rushLiveControlEn from "../../locales/en/rushLiveControl.json";
import navigationLiveEn from "../../locales/en/navigationLive.json";
import queuePlayerSheetEn from "../../locales/en/queuePlayerSheet.json";
import navigationTournamentEndedEn from "../../locales/en/navigationTournamentEnded.json";
import toursEn from "../../locales/en/tours.json";
import tourCardEn from "../../locales/en/tourCard.json";
import hotspotEn from "../../locales/en/hotspot.json";
import resourceBarEn from "../../locales/en/resourceBar.json";
import navigationCupEndedEn from "../../locales/en/navigationCupEnded.json";
import championshipEn from "../../locales/en/championship.json";
import itemChampionshipDialogEn from "../../locales/en/itemChampionshipDialog.json";
import shopEn from "../../locales/en/shop.json";
import kothLeaderboardEn from "../../locales/en/kothLeaderboard.json";
import itemMenuDialogEn from "../../locales/en/itemMenuDialog.json";
import freeGachaDialogEn from "../../locales/en/freeGachaDialog.json";
import winnerListContainerEn from "../../locales/en/winnerListContainer.json";
import passwordDialogEn from "../../locales/en/passwordDialog.json";
import luckyDrawEn from "../../locales/en/luckyDraw.json";
import onboardingEn from "../../locales/en/onboarding.json";
import onboardingMissionsEn from "../../locales/en/onboardingMissions.json";
import stepDialogEn from "../../locales/en/stepDialog.json";
import streakMissionsEn from "../../locales/en/streakMissions.json";
import eventCalendarEn from "../../locales/en/eventCalendar.json";
import vipProgramEn from "../../locales/en/vipProgram.json";

export type Locale = "en" | "zh-CN";

// Lazy load translations for other locales
const translations: Record<Locale, any> = {
  en: {
    missions: missionsEn.missions,
    changelog: changelogEn.changelog,
    leaderboard: leaderboardEn.leaderboard,
    basecamp: basecampEn.basecamp,
    preferences: preferencesEn.preferences,
    replayTutorial: replayTutorialEn.replayTutorial,
    squadList: squadListEn.squadList,
    squadPerformanceSheet: squadPerformanceSheetEn.squadPerformanceSheet,
    createSquadSheet: createSquadSheetEn.createSquadSheet,
    tokenSelectionSheetContent:
      tokenSelectionSheetContentEn.tokenSelectionSheetContent,
    deleteSquadSheet: deleteSquadSheetEn.deleteSquadSheet,
    referrals: referralsEn.referrals,
    referrer: referrerPageEn.referrer,
    practice: practiceEn.practice,
    navigationPractice: navigationPracticeEn.navigationPractice,
    directionToggle: directionToggleEn.directionToggle,
    squadListSheetContent: squadListSheetContentEn.squadListSheetContent,
    navigationPracticeLive: navigationPracticeLiveEn.navigationPracticeLive,
    userRankCard: userRankCardEn.userRankCard,
    navigationPracticeEnded: navigationPracticeEndedEn.navigationPracticeEnded,
    practiceLive: practiceLiveEn.practiceLive,
    practiceEnded: practiceEndedEn.practiceEnded,
    itemRouletteDialog: itemRouletteDialogEn.itemRouletteDialog,
    itemDoubleTrophyDialog: itemDoubleTrophyDialogEn.itemDoubleTrophyDialog,
    itemFreePassExpiredInfoDialog:
      itemFreePassExpiredInfoDialogEn.itemFreePassExpiredInfoDialog,
    itemWinterCupDialog: itemWinterCupDialogEn.itemWinterCupDialog,
    inventory: inventoryEn.inventory,
    roulette: rouletteEn.roulette,
    gachaTask: gachaTaskEn.gachaTask,
    homeCanvas: homeCanvasEn.homeCanvas,
    landingPage: landingPageEn.landingPage,
    arena: arenaEn.arena,
    koth: kothEn.koth,
    kothSquadSelectionView: kothSquadSelectionViewEn.kothSquadSelectionView,
    kothNavigationDetails: kothNavigationDetailsEn.kothNavigationDetails,
    kothNavigationEnded: kothNavigationEndedEn.kothNavigationEnded,
    kothNavigationLive: kothNavigationLiveEn.kothNavigationLive,
    kothNavigationViews: kothNavigationViewsEn.kothNavigationViews,
    kothCardGlobal: kothCardGlobalEn.kothCardGlobal,
    profile: profileEn.profile,
    socialLinkDialog: socialLinkDialogEn.socialLinkDialog,
    withdrawSheet: withdrawSheetEn.withdrawSheet,
    depositSheet: depositSheetEn.depositSheet,
    withdrawAlert: withdrawAlertEn.withdrawAlert,
    rushHistory: rushHistoryEn.rushHistory,
    tournamentCard: tournamentCardEn.tournamentCard,
    matchCard: matchCardEn.matchCard,
    kothCard: kothCardEn.kothCard,
    kothHistory: kothHistoryEn.kothHistory,
    rush: rushEn.rush,
    claimBorderDialog: claimBorderDialogEn.claimBorderDialog,
    rushLeaderboard: rushLeaderboardEn.rushLeaderboard,
    rollingList: rollingListEn.rollingList,
    payoutDialogRush: payoutDialogRushEn.payoutDialogRush,
    winnerTakesAllDetails: winnerTakesAllDetailsEn.winnerTakesAllDetails,
    winnerTakesAllHistory: winnerTakesAllHistoryEn.winnerTakesAllHistory,
    wtaRoomList: wtaRoomListEn.wtaRoomList,
    winnerTakesAllView: winnerTakesAllViewEn.winnerTakesAllView,
    hostedTournament: hostedTournamentEn.hostedTournament,
    hostedTournamentCard: hostedTournamentCardEn.hostedTournamentCard,
    hostedTournamentDetails: hostedTournamentDetailsEn.hostedTournamentDetails,
    hostedTournamentOpen: hostedTournamentOpenEn.hostedTournamentOpen,
    hostedTournamentView: hostedTournamentViewEn.hostedTournamentView,
    shareButtonDialog: shareButtonDialogEn.shareButtonDialog,
    hostedTournamentHistory: hostedTournamentHistoryEn.hostedTournamentHistory,
    matchHistory: matchHistoryEn.matchHistory,
    tournamentHistory: tournamentHistoryEn.tournamentHistory,
    wtaHistory: wtaHistoryEn.wtaHistory,
    createTournament: createTournamentEn.createTournament,
    tournamentSummaryDialog: tournamentSummaryDialogEn.tournamentSummaryDialog,
    squadMatchTypeSheet: squadMatchTypeSheetEn.squadMatchTypeSheet,
    playersJoinList: playersJoinListEn.playersJoinList,
    tournamentDetails: tournamentDetailsEn.tournamentDetails,
    tournamentOpen: tournamentOpenEn.tournamentOpen,
    tournamentEnded: tournamentEndedEn.tournamentEnded,
    dayTournamentView: dayTournamentViewEn.dayTournamentView,
    payoutDialog: payoutDialogEn.payoutDialog,
    chatWidget: chatWidgetEn.chatWidget,
    navigationMatch: navigationMatchEn.navigationMatch,
    joinButton: joinButtonEn.joinButton,
    entriesCounter: entriesCounterEn.entriesCounter,
    navigationRush: navigationRushEn.navigationRush,
    autoJoinSheet: autoJoinSheetEn.autoJoinSheet,
    roundsCounter: roundsCounterEn.roundsCounter,
    rushLiveControl: rushLiveControlEn.rushLiveControl,
    navigationLive: navigationLiveEn.navigationLive,
    queuePlayerSheet: queuePlayerSheetEn.queuePlayerSheet,
    navigationTournamentEnded:
      navigationTournamentEndedEn.navigationTournamentEnded,
    tours: toursEn.tours,
    tourCard: tourCardEn.tourCard,
    hotspot: hotspotEn.hotspot,
    resourceBar: resourceBarEn.resourceBar,
    navigationCupEnded: navigationCupEndedEn.navigationCupEnded,
    championship: championshipEn.championship,
    itemChampionshipDialog: itemChampionshipDialogEn.itemChampionshipDialog,
    shop: shopEn.shop,
    kothLeaderboard: kothLeaderboardEn.kothLeaderboard,
    itemMenuDialog: itemMenuDialogEn.itemMenuDialog,
    freeGachaDialog: freeGachaDialogEn.freeGachaDialog,
    winnerListContainer: winnerListContainerEn.winnerListContainer,
    passwordDialog: passwordDialogEn.passwordDialog,
    luckyDraw: luckyDrawEn.luckyDraw,
    onboarding: onboardingEn.onboarding,
    onboardingMissions: onboardingMissionsEn.onboardingMissions,
    stepDialog: stepDialogEn.stepDialog,
    streakMissions: streakMissionsEn.streakMissions,
    eventCalendar: eventCalendarEn.eventCalendar,
    vipProgram: vipProgramEn.vipProgram,
  },
  "zh-CN": {} as any,
};

// Function to get current locale (can be enhanced with user preference)
export function getLocale(): Locale {
  if (typeof window === "undefined") {
    return "en";
  }

  // Check localStorage for saved locale preference
  const savedLocale = localStorage.getItem("cfl:locale") as Locale | null;
  if (savedLocale && translations[savedLocale]) {
    return savedLocale;
  }

  // Fallback to browser language
  const browserLang = navigator.language.toLowerCase();
  const supportedLocales: Locale[] = ["en", "zh-CN"];

  // Check for exact match (e.g., zh-CN)
  if (supportedLocales.includes(browserLang as Locale)) {
    return browserLang as Locale;
  }

  // Check for language code match (e.g., zh from zh-TW)
  const langCode = browserLang.split("-")[0];
  if (langCode === "zh") {
    return "zh-CN";
  }

  return "en";
}

// Function to set locale
export function setLocale(locale: Locale) {
  if (typeof window !== "undefined") {
    localStorage.setItem("cfl:locale", locale);
    // Reload to apply new locale
    window.location.reload();
  }
}

// Lazy load translation files
async function loadTranslations(locale: Locale) {
  if (locale === "en") {
    return translations.en;
  }

  if (translations[locale] && Object.keys(translations[locale]).length > 0) {
    return translations[locale];
  }

  try {
    // Dynamic import - Vite will handle this at build time
    // Handle zh-CN locale path (use zh-CN folder name)
    const localePath = locale === "zh-CN" ? "zh-CN" : locale;
    const [
      missionsModule,
      changelogModule,
      leaderboardModule,
      basecampModule,
      preferencesModule,
      replayTutorialModule,
      squadListModule,
      squadPerformanceSheetModule,
      createSquadSheetModule,
      tokenSelectionSheetContentModule,
      deleteSquadSheetModule,
      referralsModule,
      referrerPageModule,
      practiceModule,
      navigationPracticeModule,
      directionToggleModule,
      squadListSheetContentModule,
      navigationPracticeLiveModule,
      userRankCardModule,
      navigationPracticeEndedModule,
      practiceLiveModule,
      practiceEndedModule,
      itemRouletteDialogModule,
      itemDoubleTrophyDialogModule,
      itemFreePassExpiredInfoDialogModule,
      itemWinterCupDialogModule,
      rouletteModule,
      gachaTaskModule,
      homeCanvasModule,
      landingPageModule,
      arenaModule,
      kothModule,
      kothSquadSelectionViewModule,
      kothNavigationDetailsModule,
      kothNavigationEndedModule,
      kothNavigationLiveModule,
      kothNavigationViewsModule,
      kothCardGlobalModule,
      profileModule,
      socialLinkDialogModule,
      withdrawSheetModule,
      depositSheetModule,
      withdrawAlertModule,
      rushHistoryModule,
      tournamentCardModule,
      matchCardModule,
      kothCardModule,
      kothHistoryModule,
      rushModule,
      claimBorderDialogModule,
      rushLeaderboardModule,
      rollingListModule,
      payoutDialogRushModule,
      winnerTakesAllDetailsModule,
      winnerTakesAllHistoryModule,
      wtaRoomListModule,
      winnerTakesAllViewModule,
      hostedTournamentModule,
      hostedTournamentCardModule,
      hostedTournamentDetailsModule,
      hostedTournamentOpenModule,
      hostedTournamentViewModule,
      shareButtonDialogModule,
      hostedTournamentHistoryModule,
      matchHistoryModule,
      tournamentHistoryModule,
      wtaHistoryModule,
      createTournamentModule,
      tournamentSummaryDialogModule,
      squadMatchTypeSheetModule,
      playersJoinListModule,
      tournamentDetailsModule,
      tournamentOpenModule,
      tournamentEndedModule,
      dayTournamentViewModule,
      payoutDialogModule,
      chatWidgetModule,
      navigationMatchModule,
      joinButtonModule,
      entriesCounterModule,
      navigationRushModule,
      autoJoinSheetModule,
      roundsCounterModule,
      rushLiveControlModule,
      navigationLiveModule,
      queuePlayerSheetModule,
      navigationTournamentEndedModule,
      toursModule,
      tourCardModule,
      hotspotModule,
      resourceBarModule,
      navigationCupEndedModule,
      championshipModule,
      itemChampionshipDialogModule,
      inventoryModule,
      shopModule,
      kothLeaderboardModule,
      itemMenuDialogModule,
      freeGachaDialogModule,
      winnerListContainerModule,
      passwordDialogModule,
      luckyDrawModule,
      onboardingModule,
      onboardingMissionsModule,
      stepDialogModule,
      streakMissionsModule,
      eventCalendarModule,
      vipProgramModule,
    ] = await Promise.all([
      import(`../../locales/${localePath}/missions.json`).catch(() => null),
      import(`../../locales/${localePath}/changelog.json`).catch(() => null),
      import(`../../locales/${localePath}/leaderboard.json`).catch(() => null),
      import(`../../locales/${localePath}/basecamp.json`).catch(() => null),
      import(`../../locales/${localePath}/preferences.json`).catch(() => null),
      import(`../../locales/${localePath}/replayTutorial.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/squadList.json`).catch(() => null),
      import(`../../locales/${localePath}/squadPerformanceSheet.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/createSquadSheet.json`).catch(
        () => null,
      ),
      import(
        `../../locales/${localePath}/tokenSelectionSheetContent.json`
      ).catch(() => null),
      import(`../../locales/${localePath}/deleteSquadSheet.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/referrals.json`).catch(() => null),
      import(`../../locales/${localePath}/referrerPage.json`).catch(() => null),
      import(`../../locales/${localePath}/practice.json`).catch(() => null),
      import(`../../locales/${localePath}/navigationPractice.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/directionToggle.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/squadListSheetContent.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/navigationPracticeLive.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/userRankCard.json`).catch(() => null),
      import(`../../locales/${localePath}/navigationPracticeEnded.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/practiceLive.json`).catch(() => null),
      import(`../../locales/${localePath}/practiceEnded.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/itemRouletteDialog.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/itemDoubleTrophyDialog.json`).catch(
        () => null,
      ),
      import(
        `../../locales/${localePath}/itemFreePassExpiredInfoDialog.json`
      ).catch(() => null),
      import(`../../locales/${localePath}/itemWinterCupDialog.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/roulette.json`).catch(() => null),
      import(`../../locales/${localePath}/gachaTask.json`).catch(() => null),
      import(`../../locales/${localePath}/homeCanvas.json`).catch(() => null),
      import(`../../locales/${localePath}/landingPage.json`).catch(() => null),
      import(`../../locales/${localePath}/arena.json`).catch(() => null),
      import(`../../locales/${localePath}/koth.json`).catch(() => null),
      import(`../../locales/${localePath}/kothSquadSelectionView.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/kothNavigationDetails.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/kothNavigationEnded.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/kothNavigationLive.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/kothNavigationViews.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/kothCardGlobal.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/profile.json`).catch(() => null),
      import(`../../locales/${localePath}/socialLinkDialog.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/withdrawSheet.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/depositSheet.json`).catch(() => null),
      import(`../../locales/${localePath}/withdrawAlert.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/rushHistory.json`).catch(() => null),
      import(`../../locales/${localePath}/tournamentCard.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/matchCard.json`).catch(() => null),
      import(`../../locales/${localePath}/kothCard.json`).catch(() => null),
      import(`../../locales/${localePath}/kothHistory.json`).catch(() => null),
      import(`../../locales/${localePath}/rush.json`).catch(() => null),
      import(`../../locales/${localePath}/claimBorderDialog.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/rushLeaderboard.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/rollingList.json`).catch(() => null),
      import(`../../locales/${localePath}/payoutDialogRush.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/winnerTakesAllDetails.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/winnerTakesAllHistory.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/wtaRoomList.json`).catch(() => null),
      import(`../../locales/${localePath}/winnerTakesAllView.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/hostedTournament.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/hostedTournamentCard.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/hostedTournamentDetails.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/hostedTournamentOpen.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/hostedTournamentView.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/shareButtonDialog.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/hostedTournamentHistory.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/matchHistory.json`).catch(() => null),
      import(`../../locales/${localePath}/tournamentHistory.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/wtaHistory.json`).catch(() => null),
      import(`../../locales/${localePath}/createTournament.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/tournamentSummaryDialog.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/squadMatchTypeSheet.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/playersJoinList.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/tournamentDetails.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/tournamentOpen.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/tournamentEnded.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/dayTournamentView.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/payoutDialog.json`).catch(() => null),
      import(`../../locales/${localePath}/chatWidget.json`).catch(() => null),
      import(`../../locales/${localePath}/navigationMatch.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/joinButton.json`).catch(() => null),
      import(`../../locales/${localePath}/entriesCounter.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/navigationRush.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/autoJoinSheet.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/roundsCounter.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/rushLiveControl.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/navigationLive.json`).catch(
        () => null,
      ),
      import(`../../locales/${localePath}/queuePlayerSheet.json`).catch(
        () => null,
      ),
      import(
        `../../locales/${localePath}/navigationTournamentEnded.json`
      ).catch(() => null),
      import(`../../locales/${localePath}/tours.json`).catch(() => null),
      import(`../../locales/${localePath}/tourCard.json`).catch(() => null),
      import(`../../locales/${localePath}/hotspot.json`).catch(() => null),
      import(`../../locales/${localePath}/resourceBar.json`).catch(() => null),
      import(`../../locales/${localePath}/navigationCupEnded.json`).catch(() => null),
      import(`../../locales/${localePath}/championship.json`).catch(() => null),
      import(`../../locales/${localePath}/itemChampionshipDialog.json`).catch(() => null),
      import(`../../locales/${localePath}/inventory.json`).catch(() => null),
      import(`../../locales/${localePath}/shop.json`).catch(() => null),
      import(`../../locales/${localePath}/kothLeaderboard.json`).catch(() => null),
      import(`../../locales/${localePath}/itemMenuDialog.json`).catch(() => null),
      import(`../../locales/${localePath}/freeGachaDialog.json`).catch(() => null),
      import(`../../locales/${localePath}/winnerListContainer.json`).catch(() => null),
      import(`../../locales/${localePath}/passwordDialog.json`).catch(() => null),
      import(`../../locales/${localePath}/luckyDraw.json`).catch(() => null),
      import(`../../locales/${localePath}/onboarding.json`).catch(() => null),
      import(`../../locales/${localePath}/onboardingMissions.json`).catch(() => null),
      import(`../../locales/${localePath}/stepDialog.json`).catch(() => null),
      import(`../../locales/${localePath}/streakMissions.json`).catch(() => null),
      import(`../../locales/${localePath}/eventCalendar.json`).catch(() => null),
      import(`../../locales/${localePath}/vipProgram.json`).catch(() => null),
    ]);

    translations[locale] = {
      missions:
        missionsModule?.default?.missions ||
        missionsModule?.missions ||
        translations.en.missions,
      changelog:
        changelogModule?.default?.changelog ||
        changelogModule?.changelog ||
        translations.en.changelog,
      leaderboard:
        leaderboardModule?.default?.leaderboard ||
        leaderboardModule?.leaderboard ||
        translations.en.leaderboard,
      basecamp:
        basecampModule?.default?.basecamp ||
        basecampModule?.basecamp ||
        translations.en.basecamp,
      preferences:
        preferencesModule?.default?.preferences ||
        preferencesModule?.preferences ||
        translations.en.preferences,
      replayTutorial:
        replayTutorialModule?.default?.replayTutorial ||
        replayTutorialModule?.replayTutorial ||
        translations.en.replayTutorial,
      squadList:
        squadListModule?.default?.squadList ||
        squadListModule?.squadList ||
        translations.en.squadList,
      squadPerformanceSheet:
        squadPerformanceSheetModule?.default?.squadPerformanceSheet ||
        squadPerformanceSheetModule?.squadPerformanceSheet ||
        translations.en.squadPerformanceSheet,
      createSquadSheet:
        createSquadSheetModule?.default?.createSquadSheet ||
        createSquadSheetModule?.createSquadSheet ||
        translations.en.createSquadSheet,
      tokenSelectionSheetContent:
        tokenSelectionSheetContentModule?.default?.tokenSelectionSheetContent ||
        tokenSelectionSheetContentModule?.tokenSelectionSheetContent ||
        translations.en.tokenSelectionSheetContent,
      deleteSquadSheet:
        deleteSquadSheetModule?.default?.deleteSquadSheet ||
        deleteSquadSheetModule?.deleteSquadSheet ||
        translations.en.deleteSquadSheet,
      referrals:
        referralsModule?.default?.referrals ||
        referralsModule?.referrals ||
        translations.en.referrals,
      referrer:
        referrerPageModule?.default?.referrer ||
        referrerPageModule?.referrer ||
        translations.en.referrer,
      practice:
        practiceModule?.default?.practice ||
        practiceModule?.practice ||
        translations.en.practice,
      navigationPractice:
        navigationPracticeModule?.default?.navigationPractice ||
        navigationPracticeModule?.navigationPractice ||
        translations.en.navigationPractice,
      directionToggle:
        directionToggleModule?.default?.directionToggle ||
        directionToggleModule?.directionToggle ||
        translations.en.directionToggle,
      squadListSheetContent:
        squadListSheetContentModule?.default?.squadListSheetContent ||
        squadListSheetContentModule?.squadListSheetContent ||
        translations.en.squadListSheetContent,
      navigationPracticeLive:
        navigationPracticeLiveModule?.default?.navigationPracticeLive ||
        navigationPracticeLiveModule?.navigationPracticeLive ||
        translations.en.navigationPracticeLive,
      userRankCard:
        userRankCardModule?.default?.userRankCard ||
        userRankCardModule?.userRankCard ||
        translations.en.userRankCard,
      navigationPracticeEnded:
        navigationPracticeEndedModule?.default?.navigationPracticeEnded ||
        navigationPracticeEndedModule?.navigationPracticeEnded ||
        translations.en.navigationPracticeEnded,
      practiceLive:
        practiceLiveModule?.default?.practiceLive ||
        practiceLiveModule?.practiceLive ||
        translations.en.practiceLive,
      practiceEnded:
        practiceEndedModule?.default?.practiceEnded ||
        practiceEndedModule?.practiceEnded ||
        translations.en.practiceEnded,
      itemRouletteDialog:
        itemRouletteDialogModule?.default?.itemRouletteDialog ||
        itemRouletteDialogModule?.itemRouletteDialog ||
        translations.en.itemRouletteDialog,
      itemDoubleTrophyDialog:
        itemDoubleTrophyDialogModule?.default?.itemDoubleTrophyDialog ||
        itemDoubleTrophyDialogModule?.itemDoubleTrophyDialog ||
        translations.en.itemDoubleTrophyDialog,
      itemFreePassExpiredInfoDialog:
        itemFreePassExpiredInfoDialogModule?.default
          ?.itemFreePassExpiredInfoDialog ||
        itemFreePassExpiredInfoDialogModule?.itemFreePassExpiredInfoDialog ||
        translations.en.itemFreePassExpiredInfoDialog,
      itemWinterCupDialog:
        itemWinterCupDialogModule?.default?.itemWinterCupDialog ||
        itemWinterCupDialogModule?.itemWinterCupDialog ||
        translations.en.itemWinterCupDialog,
      roulette:
        rouletteModule?.default?.roulette ||
        rouletteModule?.roulette ||
        translations.en.roulette,
      gachaTask:
        gachaTaskModule?.default?.gachaTask ||
        gachaTaskModule?.gachaTask ||
        translations.en.gachaTask,
      homeCanvas:
        homeCanvasModule?.default?.homeCanvas ||
        homeCanvasModule?.homeCanvas ||
        translations.en.homeCanvas,
      landingPage:
        landingPageModule?.default?.landingPage ||
        landingPageModule?.landingPage ||
        translations.en.landingPage,
      arena:
        arenaModule?.default?.arena ||
        arenaModule?.arena ||
        translations.en.arena,
      koth:
        kothModule?.default?.koth || kothModule?.koth || translations.en.koth,
      kothSquadSelectionView:
        kothSquadSelectionViewModule?.default?.kothSquadSelectionView ||
        kothSquadSelectionViewModule?.kothSquadSelectionView ||
        translations.en.kothSquadSelectionView,
      kothNavigationDetails:
        kothNavigationDetailsModule?.default?.kothNavigationDetails ||
        kothNavigationDetailsModule?.kothNavigationDetails ||
        translations.en.kothNavigationDetails,
      kothNavigationEnded:
        kothNavigationEndedModule?.default?.kothNavigationEnded ||
        kothNavigationEndedModule?.kothNavigationEnded ||
        translations.en.kothNavigationEnded,
      kothNavigationLive:
        kothNavigationLiveModule?.default?.kothNavigationLive ||
        kothNavigationLiveModule?.kothNavigationLive ||
        translations.en.kothNavigationLive,
      kothNavigationViews:
        kothNavigationViewsModule?.default?.kothNavigationViews ||
        kothNavigationViewsModule?.kothNavigationViews ||
        translations.en.kothNavigationViews,
      kothCardGlobal:
        kothCardGlobalModule?.default?.kothCardGlobal ||
        kothCardGlobalModule?.kothCardGlobal ||
        translations.en.kothCardGlobal,
      profile:
        profileModule?.default?.profile ||
        profileModule?.profile ||
        translations.en.profile,
      socialLinkDialog:
        socialLinkDialogModule?.default?.socialLinkDialog ||
        socialLinkDialogModule?.socialLinkDialog ||
        translations.en.socialLinkDialog,
      withdrawSheet:
        withdrawSheetModule?.default?.withdrawSheet ||
        withdrawSheetModule?.withdrawSheet ||
        translations.en.withdrawSheet,
      depositSheet:
        depositSheetModule?.default?.depositSheet ||
        depositSheetModule?.depositSheet ||
        translations.en.depositSheet,
      withdrawAlert:
        withdrawAlertModule?.default?.withdrawAlert ||
        withdrawAlertModule?.withdrawAlert ||
        translations.en.withdrawAlert,
      rushHistory:
        rushHistoryModule?.default?.rushHistory ||
        rushHistoryModule?.rushHistory ||
        translations.en.rushHistory,
      tournamentCard:
        tournamentCardModule?.default?.tournamentCard ||
        tournamentCardModule?.tournamentCard ||
        translations.en.tournamentCard,
      matchCard:
        matchCardModule?.default?.matchCard ||
        matchCardModule?.matchCard ||
        translations.en.matchCard,
      kothCard:
        kothCardModule?.default?.kothCard ||
        kothCardModule?.kothCard ||
        translations.en.kothCard,
      kothHistory:
        kothHistoryModule?.default?.kothHistory ||
        kothHistoryModule?.kothHistory ||
        translations.en.kothHistory,
      rush:
        rushModule?.default?.rush || rushModule?.rush || translations.en.rush,
      claimBorderDialog:
        claimBorderDialogModule?.default?.claimBorderDialog ||
        claimBorderDialogModule?.claimBorderDialog ||
        translations.en.claimBorderDialog,
      rushLeaderboard:
        rushLeaderboardModule?.default?.rushLeaderboard ||
        rushLeaderboardModule?.rushLeaderboard ||
        translations.en.rushLeaderboard,
      rollingList:
        rollingListModule?.default?.rollingList ||
        rollingListModule?.rollingList ||
        translations.en.rollingList,
      payoutDialogRush:
        payoutDialogRushModule?.default?.payoutDialogRush ||
        payoutDialogRushModule?.payoutDialogRush ||
        translations.en.payoutDialogRush,
      winnerTakesAllDetails:
        winnerTakesAllDetailsModule?.default?.winnerTakesAllDetails ||
        winnerTakesAllDetailsModule?.winnerTakesAllDetails ||
        translations.en.winnerTakesAllDetails,
      winnerTakesAllHistory:
        winnerTakesAllHistoryModule?.default?.winnerTakesAllHistory ||
        winnerTakesAllHistoryModule?.winnerTakesAllHistory ||
        translations.en.winnerTakesAllHistory,
      wtaRoomList:
        wtaRoomListModule?.default?.wtaRoomList ||
        wtaRoomListModule?.wtaRoomList ||
        translations.en.wtaRoomList,
      winnerTakesAllView:
        winnerTakesAllViewModule?.default?.winnerTakesAllView ||
        winnerTakesAllViewModule?.winnerTakesAllView ||
        translations.en.winnerTakesAllView,
      hostedTournament:
        hostedTournamentModule?.default?.hostedTournament ||
        hostedTournamentModule?.hostedTournament ||
        translations.en.hostedTournament,
      hostedTournamentCard:
        hostedTournamentCardModule?.default?.hostedTournamentCard ||
        hostedTournamentCardModule?.hostedTournamentCard ||
        translations.en.hostedTournamentCard,
      hostedTournamentDetails:
        hostedTournamentDetailsModule?.default?.hostedTournamentDetails ||
        hostedTournamentDetailsModule?.hostedTournamentDetails ||
        translations.en.hostedTournamentDetails,
      hostedTournamentOpen:
        hostedTournamentOpenModule?.default?.hostedTournamentOpen ||
        hostedTournamentOpenModule?.hostedTournamentOpen ||
        translations.en.hostedTournamentOpen,
      hostedTournamentView:
        hostedTournamentViewModule?.default?.hostedTournamentView ||
        hostedTournamentViewModule?.hostedTournamentView ||
        translations.en.hostedTournamentView,
      shareButtonDialog:
        shareButtonDialogModule?.default?.shareButtonDialog ||
        shareButtonDialogModule?.shareButtonDialog ||
        translations.en.shareButtonDialog,
      hostedTournamentHistory:
        hostedTournamentHistoryModule?.default?.hostedTournamentHistory ||
        hostedTournamentHistoryModule?.hostedTournamentHistory ||
        translations.en.hostedTournamentHistory,
      matchHistory:
        matchHistoryModule?.default?.matchHistory ||
        matchHistoryModule?.matchHistory ||
        translations.en.matchHistory,
      tournamentHistory:
        tournamentHistoryModule?.default?.tournamentHistory ||
        tournamentHistoryModule?.tournamentHistory ||
        translations.en.tournamentHistory,
      wtaHistory:
        wtaHistoryModule?.default?.wtaHistory ||
        wtaHistoryModule?.wtaHistory ||
        translations.en.wtaHistory,
      createTournament:
        createTournamentModule?.default?.createTournament ||
        createTournamentModule?.createTournament ||
        translations.en.createTournament,
      tournamentSummaryDialog:
        tournamentSummaryDialogModule?.default?.tournamentSummaryDialog ||
        tournamentSummaryDialogModule?.tournamentSummaryDialog ||
        translations.en.tournamentSummaryDialog,
      squadMatchTypeSheet:
        squadMatchTypeSheetModule?.default?.squadMatchTypeSheet ||
        squadMatchTypeSheetModule?.squadMatchTypeSheet ||
        translations.en.squadMatchTypeSheet,
      playersJoinList:
        playersJoinListModule?.default?.playersJoinList ||
        playersJoinListModule?.playersJoinList ||
        translations.en.playersJoinList,
      tournamentDetails:
        tournamentDetailsModule?.default?.tournamentDetails ||
        tournamentDetailsModule?.tournamentDetails ||
        translations.en.tournamentDetails,
      tournamentOpen:
        tournamentOpenModule?.default?.tournamentOpen ||
        tournamentOpenModule?.tournamentOpen ||
        translations.en.tournamentOpen,
      tournamentEnded:
        tournamentEndedModule?.default?.tournamentEnded ||
        tournamentEndedModule?.tournamentEnded ||
        translations.en.tournamentEnded,
      dayTournamentView:
        dayTournamentViewModule?.default?.dayTournamentView ||
        dayTournamentViewModule?.dayTournamentView ||
        translations.en.dayTournamentView,
      payoutDialog:
        payoutDialogModule?.default?.payoutDialog ||
        payoutDialogModule?.payoutDialog ||
        translations.en.payoutDialog,
      chatWidget:
        chatWidgetModule?.default?.chatWidget ||
        chatWidgetModule?.chatWidget ||
        translations.en.chatWidget,
      navigationMatch:
        navigationMatchModule?.default?.navigationMatch ||
        navigationMatchModule?.navigationMatch ||
        translations.en.navigationMatch,
      joinButton:
        joinButtonModule?.default?.joinButton ||
        joinButtonModule?.joinButton ||
        translations.en.joinButton,
      entriesCounter:
        entriesCounterModule?.default?.entriesCounter ||
        entriesCounterModule?.entriesCounter ||
        translations.en.entriesCounter,
      navigationRush:
        navigationRushModule?.default?.navigationRush ||
        navigationRushModule?.navigationRush ||
        translations.en.navigationRush,
      autoJoinSheet:
        autoJoinSheetModule?.default?.autoJoinSheet ||
        autoJoinSheetModule?.autoJoinSheet ||
        translations.en.autoJoinSheet,
      roundsCounter:
        roundsCounterModule?.default?.roundsCounter ||
        roundsCounterModule?.roundsCounter ||
        translations.en.roundsCounter,
      rushLiveControl:
        rushLiveControlModule?.default?.rushLiveControl ||
        rushLiveControlModule?.rushLiveControl ||
        translations.en.rushLiveControl,
      navigationLive:
        navigationLiveModule?.default?.navigationLive ||
        navigationLiveModule?.navigationLive ||
        translations.en.navigationLive,
      queuePlayerSheet:
        queuePlayerSheetModule?.default?.queuePlayerSheet ||
        queuePlayerSheetModule?.queuePlayerSheet ||
        translations.en.queuePlayerSheet,
      navigationTournamentEnded:
        navigationTournamentEndedModule?.default?.navigationTournamentEnded ||
        navigationTournamentEndedModule?.navigationTournamentEnded ||
        translations.en.navigationTournamentEnded,
      tours:
        toursModule?.default?.tours ||
        toursModule?.tours ||
        translations.en.tours,
      tourCard:
        tourCardModule?.default?.tourCard ||
        tourCardModule?.tourCard ||
        translations.en.tourCard,
      hotspot:
        hotspotModule?.default?.hotspot ||
        hotspotModule?.hotspot ||
        translations.en.hotspot,
      resourceBar:
        resourceBarModule?.default?.resourceBar ||
        resourceBarModule?.resourceBar ||
        translations.en.resourceBar,
      navigationCupEnded:
        navigationCupEndedModule?.default?.navigationCupEnded ||
        navigationCupEndedModule?.navigationCupEnded ||
        translations.en.navigationCupEnded,
      championship:
        championshipModule?.default?.championship ||
        championshipModule?.championship ||
        translations.en.championship,
      itemChampionshipDialog:
        itemChampionshipDialogModule?.default?.itemChampionshipDialog ||
        itemChampionshipDialogModule?.itemChampionshipDialog ||
        translations.en.itemChampionshipDialog,
      shop:
        shopModule?.default?.shop ||
        shopModule?.shop ||
        translations.en.shop,
      inventory:
        inventoryModule?.default?.inventory ||
        inventoryModule?.inventory ||
        translations.en.inventory,
      kothLeaderboard:
        kothLeaderboardModule?.default?.kothLeaderboard ||
        kothLeaderboardModule?.kothLeaderboard ||
        translations.en.kothLeaderboard,
      itemMenuDialog:
        itemMenuDialogModule?.default?.itemMenuDialog ||
        itemMenuDialogModule?.itemMenuDialog ||
        translations.en.itemMenuDialog,
      freeGachaDialog:
        freeGachaDialogModule?.default?.freeGachaDialog ||
        freeGachaDialogModule?.freeGachaDialog ||
        translations.en.freeGachaDialog,
      winnerListContainer:
        winnerListContainerModule?.default?.winnerListContainer ||
        winnerListContainerModule?.winnerListContainer ||
        translations.en.winnerListContainer,
      passwordDialog:
        passwordDialogModule?.default?.passwordDialog ||
        passwordDialogModule?.passwordDialog ||
        translations.en.passwordDialog,
      luckyDraw:
        luckyDrawModule?.default?.luckyDraw ||
        luckyDrawModule?.luckyDraw ||
        translations.en.luckyDraw,
      onboarding:
        onboardingModule?.default?.onboarding ||
        onboardingModule?.onboarding ||
        translations.en.onboarding,
      onboardingMissions:
        onboardingMissionsModule?.default?.onboardingMissions ||
        onboardingMissionsModule?.onboardingMissions ||
        translations.en.onboardingMissions,
      stepDialog:
        stepDialogModule?.default?.stepDialog ||
        stepDialogModule?.stepDialog ||
        translations.en.stepDialog,
      streakMissions:
        streakMissionsModule?.default?.streakMissions ||
        streakMissionsModule?.streakMissions ||
        translations.en.streakMissions,
      eventCalendar:
        eventCalendarModule?.default?.eventCalendar ||
        eventCalendarModule?.eventCalendar ||
        translations.en.eventCalendar,
      vipProgram:
        vipProgramModule?.default?.vipProgram ||
        vipProgramModule?.vipProgram ||
        translations.en.vipProgram,
    };
    return translations[locale];
  } catch (error) {
    console.warn(`Failed to load translations for locale: ${locale}`, error);
    return translations.en; // Fallback to English
  }
}

// Translation function with interpolation support
export function t(
  key: string,
  params?: Record<string, string | number>,
): string {
  const locale = getLocale();

  // Ensure translations are loaded for current locale
  if (
    locale !== "en" &&
    (!translations[locale] || Object.keys(translations[locale]).length === 0)
  ) {
    // Load translations synchronously if not already loaded
    loadTranslations(locale).catch(console.error);
  }

  const translation = translations[locale] || translations.en;

  const keys = key.split(".");
  let value: any = translation;

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      // Fallback to English
      value = translations.en;
      for (const fallbackKey of keys) {
        value = value?.[fallbackKey];
      }
      break;
    }
  }

  if (typeof value !== "string") {
    console.warn(`Translation key "${key}" not found or not a string`);
    return key;
  }

  // Replace placeholders with params
  if (params) {
    return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey]?.toString() || match;
    });
  }

  return value;
}

// Initialize translations on load
if (typeof window !== "undefined") {
  const locale = getLocale();
  if (locale !== "en") {
    loadTranslations(locale).catch(console.error);
  }
}
